export default __webpack_public_path__ + "static/media/a008-2.cad26897.svg";